import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import styled from "styled-components";
import { FormType } from "../../model/backoffice/document-type";
import { AddDays, AlertError } from "../../core/Helper";
import { FormObjectService } from "../../core/FieldObject";
import {
  CalcSummary,
  GetInvoiceFooterObject,
  GetInvoiceHeaderObject,
  GetRunningDocu,
  LoadCustomer,
  LoadDocuList,
} from "../../core/BillingComponents";

import {
  DefaultBillViewer,
  DefaultEditorValue,
  GetEditorForm,
} from "../../core/Helper2";
import { DocumentService } from "../../model/backoffice/document";
import { StudyService } from "../../model/study";

import FormReceipt from "./003_receipt";
import { Button } from "react-bootstrap";
import { FaFileInvoice } from "react-icons/fa";

import { SearchCustomer } from "../../model/customer";
import { DefaultState } from "../components/SearchTypeB";
import SearchBigData from "../components/SearchBigData";
import BillViewer, {
  FormDocuType,
} from "../../components/bill-forms/BillViewer";
import FormAutoObject from "../../core/FormAutoObject";

/**
 * Main Invoice form ....
 * @param {*} props
 * @returns
 */
export default function FormInvoice(props) {
  const documentIdFieldName = "DocuInvoiceId";
  const userInfo = useSelector((state) => state.user.detail);
  const ref1 = useRef();
  const ref2 = useRef();
  const [form, setForm] = useState();
  // const [headData, setHeadData] = useState({});
  const [objHead, setObjHead] = useState(null);
  const [objSum, setObjSum] = useState(null);
  // const [sumData, setSumData] = useState({});
  // const [customer, setCustomer] = useState();
  const [docuList, setDocuList] = useState([]);
  const [runningDocu, setRunningDocu] = useState();
  const [billViewer, setBillViewer] = useState(DefaultBillViewer);
  const [receiptForm, setReceiptForm] = useState(DefaultEditorValue);
  const [data, setData] = useState({});
  const [searchBig, setSearchBig] = useState(DefaultState);

  const [editor, setEditor] = props.editor;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  /*** */
  useEffect(() => {
    if (editor.show) {
      setReceiptForm(DefaultEditorValue);
      LoadDocuList([userInfo, setDocuList], FormType.INVOICE);
      return () => {
        setDocuList([]);
        setBillViewer(null);
        setRunningDocu(null);

        setForm(null);
        setData({});
        setObjHead(null);
        setObjSum(null);
        setReceiptForm(null);
      };
    }
  }, [editor.show]);

  //** after load branch document */
  useEffect(() => {
    if (editor.show && docuList) {
      const loadOld = async () => {
        setLoading(true);
        await checkStudysInvoiceExist([
          editor,
          userInfo,
          data,
          setData,
          setRunningDocu,
        ]);
        setLoading(false);
      };
      loadOld();
    }
  }, [docuList]);

  // เปลี่ยนเลขที่เอกสาร
  useEffect(() => {
    if (data?.DocuBranch) {
      // check old document-id

      let invId = data?.[documentIdFieldName];
      if (!invId) {
        // get latest running no if no invoice-id isfound
        if (data?.DocuInvoiceId <= 0) {
          GetRunningDocu([data, setData, userInfo, setRunningDocu]);
        }
      }
    }
  }, [data?.DocuBranch]);

  //* Discount effected. เมื่อมีการระบุส่วนลด หรือภาษีหัก ณ ที่จ่าย
  useEffect(() => {
    if (data?.Discount !== undefined) {
      CalcSummary([runningDocu, sumItem, data, setData, editor]);
    }
  }, [data?.Discount, data?.HoldingTaxRate, runningDocu]);

  useEffect(() => {
    if (data) {
      data.DocuDueDate = AddDays(new Date(), data?.CreditDays ?? 0);
    }
  }, [data?.CreditDays]);

  const actionSave = async () => {
    if (data?.Customer?.CustId === 0) {
      AlertError("กรุณาระบุลูกค้า", dispatch);
      return;
    }

    setEditor((pv) => ({ ...pv, wait: true }));
    let res = await DocumentService.SaveInvoice(
      {
        ...data,
        // *****
        // overide DocuBranch with running-document
        DocuBranch: runningDocu,
        Study: {
          PacsStudyId: editor.study?.pacs_study_id ?? 0,
        },
      },
      userInfo
    );

    setEditor((pv) => ({ ...pv, wait: false }));
    if (res) {
      if (res?.Message == "Error") {
        AlertError(res?.Data ?? "พบปัญหาการบันทึก", dispatch);
        return;
      }

      setData((pv) => ({
        ...pv,
        [documentIdFieldName]: res[documentIdFieldName],
      }));
      setData(res);
    }
  };

  // build PDF
  const printAction = async () => {
    setBillViewer((pv) => ({
      ...pv,
      show: true,
      formDocuType: FormDocuType.INVOICE,
    }));
  };

  /** Customer  */
  const custClick = (item) => {
    SearchCustomer(
      [setSearchBig, data, setData, userInfo, item],
      async (result) => {
        await LoadCustomer(result?.custid, [userInfo, setData]);
        setSearchBig((pv) => ({ ...pv, show: false }));
      }
    );
  };
  const buildObjHead = async () => {
    if (!editor?.show) return;
    setObjHead(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetInvoiceHeaderObject({
              docuList: docuList,
              custClick,
              docuFieldIdName: documentIdFieldName,
              head: data,
            })
          ),
          dataValue: [data, setData],
          refTo: ref1,
        }}
      />
    );
  };

  const buildObjSum = async () => {
    if (!editor?.show) return;
    // ref2?.current?.reset();
    setObjSum(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetInvoiceFooterObject({})
          ),
          dataValue: [data, setData],
          refTo: ref2,
        }}
      />
    );
  };

  useEffect(() => {
    if (editor?.show && data) {
      buildObjHead();
      buildObjSum();
    }
  }, [data, billViewer]);

  useEffect(() => {
    if (!editor?.show) return;
    setsForms();
  }, [objHead, objSum, receiptForm, searchBig]);

  // Build Form
  const setsForms = async () => {
    setForm(
      <DivMain>
        <DivLeft>{objHead}</DivLeft>
        <DivRight>{objSum}</DivRight>

        <BillViewer
          {...{
            billViewer: [billViewer, setBillViewer],
            data: [data, setData],
            // study: { ...editor.study, studyItems: editor.items },
          }}
        ></BillViewer>

        <FormReceipt
          {...{
            editor: [receiptForm, setReceiptForm],
          }}
        />
        <SearchBigData {...{ winState: [searchBig, setSearchBig] }} />
      </DivMain>
    );
  };

  const receiptButtons = () => {
    if (!data?.[documentIdFieldName]) return <></>;
    return (
      <div>
        <Button
          onClick={(e) =>
            showInvoiceEditor([receiptForm, setReceiptForm, editor, data])
          }
        >
          <FaFileInvoice color="#00ff00" size={30} />
          ออกใบเสร็จรับเงิน(ต่อ)
        </Button>
      </div>
    );
  };

  return (
    <>
      {form ? (
        <GetEditorForm
          {...{
            size: "xl",
            title: `เอกสาร INVOICE`,
            editor: [editor, setEditor],
            form: [form, setForm],
            saveData: actionSave,
            saveButtonTitle: data?.[documentIdFieldName]
              ? "แก้ไข Invoice"
              : "บันทึก Invoice",
            otherButtons: receiptButtons(),
            print: {
              action: printAction,
              disabled: false,
              hidden: data?.[documentIdFieldName] === 0,
              // hidden: data === null,
            },
          }}
        ></GetEditorForm>
      ) : (
        <></>
      )}
    </>
  );
}

//** Sum price from study item */
const sumItem = ([editor]) => {
  let amnt = 0;
  editor.items[0]?.map((r) => {
    amnt = amnt + Number(r.total);
  });
  return amnt;
};

//** Load Lastest issued invoice */
const checkStudysInvoiceExist = async ([
  editor,
  userInfo,
  data,
  setData,
  setRunningDocu,
]) => {
  let invoice = await StudyService.GetAllInvoice(
    { PacsStudyId: editor?.study?.pacs_study_id },
    userInfo
  );

  if (invoice && invoice.length > 0) {
    let cInv = invoice[invoice.length - 1];
    setRunningDocu(cInv.DocuBranch);
    setData(cInv);
  } else {
    setData({});
  }
};

/**  Show Invoice */
const showInvoiceEditor = ([receiptForm, setReceiptForm, editor, data]) => {
  setReceiptForm({
    show: true,
    action: () => {},
    invoiceInfo: data,
  });
};

const DivMain = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const DivLeft = styled.div`
  flex: 1;
  width: 100%;
  margin-inline-end: 5px;
`;
const DivRight = styled.div`
  margin-inline-start: 30px;
  width: 300px;
`;
